export const UpdateSettings = (key, value) => {
    const savedSettings = JSON.parse(localStorage.getItem('settings')) || {};
    let newSettings = { ...savedSettings };
    newSettings[key] = value;
    localStorage.setItem('settings', JSON.stringify(newSettings));
    return newSettings;
}